import React from 'react';

type ListItemProps = {
  item: {};
  children: [];
};

export default function ListItem({ item, children }: ListItemProps) {
  return <li>{children}</li>;
}
